import { connect } from 'react-redux';
import { prop } from 'ramda';
import { compose, lifecycle, withHandlers } from 'recompose';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { getAdData } from '@olxbr/mojo-jojo/selectors/ad';
import WelcomeTooltip from './WelcomeTooltip';

const getName = prop('name');
const getAdId = prop('legacyAdId');
const getListId = prop('listId');

const mapStateToProps = state => ({
  adId: getAdId(getAdData(state)),
  listId: getListId(getAdData(state)),
  pointOfSale: getName(getPOSData(state)),
});

const configureHandlers = withHandlers({
  onHide: () => () => {},
});

const configureLifecycle = lifecycle({
  componentDidMount() {},
});

export default compose(
  connect(mapStateToProps, null),
  configureLifecycle,
  configureHandlers,
)(WelcomeTooltip);
